import { ExternalLink } from "lucide-react";

const HELPCENTER_URL =
	import.meta.env.VITE_HELPCENTER_URL || "https://hilfe.dentdesk.ch";

interface HelpcenterLinkProps {
	path: string;
}

export const HelpcenterLink: React.FC<HelpcenterLinkProps> = ({ path }) => {
	return (
		<a
			href={`${HELPCENTER_URL}/${path}`}
			target="_blank"
			rel="noopener noreferrer"
			className="flex items-center gap-1 text-xs text-gray-500 hover:text-gray-700 transition-colors"
		>
			<ExternalLink className="h-3 w-3" />
			Im Hilfezentrum öffnen
		</a>
	);
};
